import axios from "axios";
import axiosLexaApiPrivate from "./api/axiosLexaApiPrivate";

let appConfig = require("./app-config");
const env = process.env.REACT_APP_BUILD_ENV
  ? process.env.REACT_APP_BUILD_ENV
  : process.env.BUILD_ENV
  ? process.env.BUILD_ENV
  : process.env.NODE_ENV;
appConfig = appConfig[env];

// ----------------------------------------------------------------------

const httpBase = axios.create({
  baseURL: appConfig.api.baseUrl,
  headers: {
    "Content-type": "application/json",
    lbcOAkey: appConfig.api.lbcOAkey,
  },
});

const httpCommonRef = axios.create({
  baseURL: appConfig.api.lbccommonrefv2Url,
  headers: {
    "Content-type": "application/json",
    lbcOAkey: appConfig.api.lbccommonrefv2LbcOAkey,
  },
});

// Lexa calls are relayed by corp-dash-api (see api/lexaProxyAuth.js).
const httpLexaApi = axiosLexaApiPrivate;

const httpTrackingApi = axios.create({
  baseURL: appConfig.api.trackingUrl,
  headers: {
    "Content-type": "text/xml",
    lbcOAkey: appConfig.api.trackingLBCOAkey,
  },
});

export { httpBase, httpCommonRef, httpLexaApi, httpTrackingApi };
